/* tslint:disable */
/* eslint-disable */
/**
 * Plateformes API
 * API for managing plateformes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MinimalPlateformeDto
 */
export interface MinimalPlateformeDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalPlateformeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPlateformeDto
     */
    name: string;
    /**
     * Mode de connexion : STANDARD (connexion Confiancia) ou SSO_PARTENAIRE (les adhérents arrivent par le SSO du partenaire).
     * @type {string}
     * @memberof MinimalPlateformeDto
     */
    modeConnexion?: MinimalPlateformeDtoModeConnexionEnum;
}


/**
 * @export
 */
export const MinimalPlateformeDtoModeConnexionEnum = {
    Standard: 'STANDARD',
    SsoPartenaire: 'SSO_PARTENAIRE'
} as const;
export type MinimalPlateformeDtoModeConnexionEnum = typeof MinimalPlateformeDtoModeConnexionEnum[keyof typeof MinimalPlateformeDtoModeConnexionEnum];


/**
 * Check if a given object implements the MinimalPlateformeDto interface.
 */
export function instanceOfMinimalPlateformeDto(value: object): value is MinimalPlateformeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function MinimalPlateformeDtoFromJSON(json: any): MinimalPlateformeDto {
    return MinimalPlateformeDtoFromJSONTyped(json, false);
}

export function MinimalPlateformeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MinimalPlateformeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'modeConnexion': json['modeConnexion'] == null ? undefined : json['modeConnexion'],
    };
}

export function MinimalPlateformeDtoToJSON(json: any): MinimalPlateformeDto {
    return MinimalPlateformeDtoToJSONTyped(json, false);
}

export function MinimalPlateformeDtoToJSONTyped(value?: MinimalPlateformeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'modeConnexion': value['modeConnexion'],
    };
}

